// Climbing-related terms for handle generation
const climbingTerms = {
  actions: [
    "climb",
    "send",
    "flash",
    "redpoint",
    "onsight",
    "dyno",
    "crimp",
    "pinch",
    "slap",
    "mantle",
    "stem",
    "layback",
    "heel",
    "toe",
    "flag",
    "selfmantle",
    "pssat",
    "paf",
  ],
  features: [
    "hold",
    "jug",
    "crimp",
    "sloper",
    "pocket",
    "pinch",
    "volume",
    "macro",
    "edge",
    "rail",
    "arete",
    "dihedral",
    "overhang",
    "slab",
    "face",
    "crack",
  ],
  grades: [
    "v0",
    "v1",
    "v2",
    "v3",
    "v4",
    "v5",
    "v6",
    "v7",
    "v8",
    "v9",
    "v10",
    "v11",
    "v12",
    "v13",
    "v14",
    "v15",
    "v16",
    "v17",
    "5a",
    "5b",
    "5c",
    "6a",
    "6b",
    "6c",
    "7a",
    "7b",
    "7c",
    "8a",
    "8b",
    "8c",
    "9a",
  ],
  adjectives: [
    "strong",
    "smooth",
    "dynamic",
    "static",
    "powerful",
    "technical",
    "crispy",
    "steep",
    "vertical",
    "wild",
    "gnarly",
    "epic",
    "solid",
    "sketchy",
    "burly",
  ],
  nouns: [
    "modeler",
    "crusher",
    "sender",
    "climber",
    "beta",
    "project",
    "flash",
    "sequence",
    "problem",
    "route",
    "line",
    "wall",
    "rock",
    "granite",
    "limestone",
  ],
};

export const generateClimbingHandle = (): string => {
  const patterns = [
    () => {
      // adjective + noun + number
      const adj =
        climbingTerms.adjectives[
          Math.floor(Math.random() * climbingTerms.adjectives.length)
        ];
      const noun =
        climbingTerms.nouns[
          Math.floor(Math.random() * climbingTerms.nouns.length)
        ];
      const num = Math.floor(Math.random() * 999) + 1;
      return `${adj}${noun}${num}`;
    },
    () => {
      // action + feature
      const action =
        climbingTerms.actions[
          Math.floor(Math.random() * climbingTerms.actions.length)
        ];
      const feature =
        climbingTerms.features[
          Math.floor(Math.random() * climbingTerms.features.length)
        ];
      const num = Math.floor(Math.random() * 99) + 1;
      return `${action}${feature}${num}`;
    },
    () => {
      // grade + adjective + noun
      const grade =
        climbingTerms.grades[
          Math.floor(Math.random() * climbingTerms.grades.length)
        ];
      const adj =
        climbingTerms.adjectives[
          Math.floor(Math.random() * climbingTerms.adjectives.length)
        ];
      const noun =
        climbingTerms.nouns[
          Math.floor(Math.random() * climbingTerms.nouns.length)
        ];
      return `${grade}${adj}${noun}`;
    },
    () => {
      // noun + action + number
      const noun =
        climbingTerms.nouns[
          Math.floor(Math.random() * climbingTerms.nouns.length)
        ];
      const action =
        climbingTerms.actions[
          Math.floor(Math.random() * climbingTerms.actions.length)
        ];
      const num = Math.floor(Math.random() * 999) + 1;
      return `${noun}${action}${num}`;
    },
    () => {
      // feature + adjective
      const feature =
        climbingTerms.features[
          Math.floor(Math.random() * climbingTerms.features.length)
        ];
      const adj =
        climbingTerms.adjectives[
          Math.floor(Math.random() * climbingTerms.adjectives.length)
        ];
      const num = Math.floor(Math.random() * 99) + 1;
      return `${feature}${adj}${num}`;
    },
  ];

  const selectedPattern = patterns[Math.floor(Math.random() * patterns.length)];
  return selectedPattern();
};
